import bike from '../../images/bike.png';
import car from '../../images/car.png';
import bus from '../../images/bus.png';
import train from '../../images/train.png';

export const transportsData = [
    {id: 1, name: 'Bike', image: bike, price: 60, seats: 1 },
    {id: 2, name: 'Bike', image: bike, price: 70, seats: 1 },
    {id: 3, name: 'Bike', image: bike, price: 80, seats: 1 },
    {id: 4, name: 'Bike', image: bike, price: 90, seats: 1 },

    {id: 5, name: 'Car', image: car, price: 130, seats: 4 },
    {id: 6, name: 'Car', image: car, price: 140, seats: 4 },
    {id: 7, name: 'Car', image: car, price: 150, seats: 4 },
    {id: 8, name: 'Car', image: car, price: 160, seats: 4 },

    {id: 9, name: 'Bus', image: bus, price: 10, seats: 25 },
    {id: 10, name: 'Bus', image: bus, price: 20, seats: 25 },
    {id: 11, name: 'Bus', image: bus, price: 30, seats: 25 },
    {id: 12, name: 'Bus', image: bus, price: 40, seats: 25 },
    
    {id: 13, name: 'Train', image: train, price: 500, seats: 125 },
    {id: 14, name: 'Train', image: train, price: 600, seats: 125 },
    {id: 15, name: 'Train', image: train, price: 700, seats: 125 },
    {id: 16, name: 'Train', image: train, price: 800, seats: 125 }
]